<template>
  <div>
    <div class="form-wrap">
      <div class="form-list py-3">

        <div class="row pt-1 description-area">
          <p class="col-12 mb-1" style="text-align:left;padding:0 2.5rem;"><b><trans-text i18nKey="ui[92][2]" :isHtml="true"/></b></p>
          <ul class="col-12 list-disc-styled" style="padding: 0px 3rem;">
            <li><trans-text i18nKey="ui[92][3]" /></li>
            <li><trans-text i18nKey="ui[92][4]" /></li>
            <li><trans-text i18nKey="ui[92][5]" /></li>
            <li><trans-text i18nKey="ui[92][6]" /></li>
            <li><trans-text i18nKey="ui[92][7]" /></li>
          </ul>
          <p class="col-12 mb-1" style="text-align:left;padding:0 2.5rem;"><b><trans-text i18nKey="ui[92][8]" :isHtml="true"/></b></p>
          <ul class="col-12 list-disc-styled" style="padding: 0px 3rem;">
            <li><trans-text i18nKey="ui[92][9]" /></li>
            <li><trans-text i18nKey="ui[92][10]" /></li>
            <li><trans-text i18nKey="ui[92][11]" /></li>
          </ul>

          <p class="col-12 mb-1" style="text-align:left;padding:0 2.5rem;"><i class="fa fa-asterisk" aria-hidden="true" style="font-size:0.8em"></i> <trans-text i18nKey="ui[92][12]" :isHtml="true"/></p>
          <p class="col-12 mb-1" style="text-align:left;padding:0 2.5rem;"><trans-text i18nKey="ui[92][13]" :isHtml="true"/></p>

          <p class="col-12 mb-5" style="text-align:left;padding:0 2.5rem;"><a href="https://www.google.co.jp/chrome/browser/desktop/">https://www.google.co.jp/chrome/browser/desktop/</a></p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  export default {
    name:"",
    components: {
    },
    data () {
      return {
      }
    },
    created(){
    },
    methods:{
    }
  }
</script>


<style lang="scss" scoped>


</style>



// WEBPACK FOOTER //
// PageForm.vue?7cfa7fdc